/**
 * Which icon ids resolve inside the document and which come from the external
 * sprite (VIP-12355).
 *
 * SvgWrapper points DOCUMENT_ICON_IDS at "#id" and every other id at
 * assets/images/icon-sprite.svg#id. Each inline set is guarded by its
 * component's spec: an id listed here but not inlined renders nothing, and a
 * symbol inlined but not listed is fetched a second time from the sprite.
 */

/** Inlined by IconSetCritical: paints above the fold on every page type. */
export const CRITICAL_ICON_IDS = new Set([
  // header and USP bar
  'icon_svg_close',
  'icon_svg_phone',
  'icon_svg_delivery_free',
  'icon_svg_money_return',
  'icon_svg_user',
  'icon_svg_down',
  'icon_svg_heart',
  'icon_svg_cart',
  'icon_svg_hamburger_menu',
  'icon_svg_search',
  // product stage and tiles: rating hearts, price and delivery info
  'icon_svg_heart_filled',
  'icon_svg_info_filled',
  // category page: filter button (mobile) and filter accordions (desktop)
  'icon_svg_filter',
  'icon_svg_minus',
  'icon_svg_plus'
])

/** Inlined by IconSetHeart: the fractional rating hearts. */
export const HEART_ICON_IDS = new Set([
  'icon_svg_heart_empty',
  'icon_svg_heart_1_4',
  'icon_svg_heart_1_2',
  'icon_svg_heart_3_4',
  'icon_svg_heart_full'
])

/** Every id SvgWrapper resolves against the document itself. */
export const DOCUMENT_ICON_IDS = new Set([
  ...CRITICAL_ICON_IDS,
  ...HEART_ICON_IDS
])
